export var CONTAINER_CLASS = "hg-modal-container";
export var DEFAULT_ANIM_DURATION = 300;
export var DEFAULT_CONTAINER_ID = "_HG_MODAL_CONTAINER";
export var TRANSITION_CLASSNAMES = {
    appear: "enter",
    appearActive: "enter-active",
    appearDone: "enter-done",
    enter: "enter",
    enterActive: "enter-active",
    enterDone: "enter-done",
    exit: "exit",
    exitActive: "exit-active",
    exitDone: "exit-done",
};
export var DEFAULT_TRANSITION_CLASSNAMES = {
    appear: "default-enter",
    appearActive: "default-enter-active",
    appearDone: "default-enter-done",
    enter: "default-enter",
    enterActive: "default-enter-active",
    enterDone: "default-enter-done",
    exit: "default-exit",
    exitActive: "default-exit-active",
    exitDone: "default-exit-done",
};
export var noop = function () { };
